/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Free_Feat3Inputs */

const en_mk_price_free_feat3 = /** @type {(inputs: Mk_Price_Free_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14-day full-feature trial`)
};

const id_mk_price_free_feat3 = /** @type {(inputs: Mk_Price_Free_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial 14 hari fitur lengkap`)
};

/**
* | output |
* | --- |
* | "14-day full-feature trial" |
*
* @param {Mk_Price_Free_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_free_feat3 = /** @type {((inputs?: Mk_Price_Free_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Free_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_free_feat3(inputs)
	return en_mk_price_free_feat3(inputs)
});